/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  const CART_EST_THRESHOLD = 2;

  async function updateCartEstShipping() {
    let cart;
    try {
      const res = await fetch('/cart.js');
      cart = await res.json();
    } catch(e) { return; }

    if (!cart.items || cart.items.length === 0) return;

    const items = cart.items;
    const handles = [...new Set(items.map(i => i.handle))];

    const metafields = {};
    await Promise.all(handles.map(async (handle) => {
      try {
        const res = await fetch(`/products/${handle}?view=est-data`);
        const text = await res.text();
        const data = JSON.parse(text.trim());
        Object.assign(metafields, data);
      } catch(e) {}
    }));

    items.forEach(function(item) {
      const mf = metafields[item.variant_id] || { est: '', zaiko: 999 };
      const expected = (mf.zaiko <= CART_EST_THRESHOLD && mf.est) ? mf.est : '';
      const current = item.properties ? (item.properties['_est_shipping'] || '') : '';
      if (current === expected) return;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: item.key, properties: { '_est_shipping': expected } })
      });
    });
  }

  document.addEventListener('theme:variant:change', function(event) {
    var variant = event.detail.variant;
    var container = event.target;
    if (variant) {
      console.log('Container ———————— ↓');
      console.log(container);
      console.log('Variant —————————— ↓');
      console.log(variant);
    }
  });

  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
    }
    updateCartEstShipping();
  });

  document.addEventListener('theme:cart:init', function(e) {
    console.log('theme:cart:init');
    console.log(e);
    updateCartEstShipping();
  });

  var cartDrawerEl = document.querySelector('[data-drawer="drawer-cart"]');
  if (cartDrawerEl) {
    cartDrawerEl.addEventListener('theme:drawer:open', updateCartEstShipping);
  }

  if (window.location.pathname === '/cart') {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', updateCartEstShipping);
    } else {
      updateCartEstShipping();
    }
  }

  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });
  document.addEventListener('theme:resize', e => { console.log(e); });

})();

(function() {
  // α-RECOVERY バッジ: 複数メッセージをフェードで巡回（スライドショー）
  // 背景幅は表示中メッセージの文字幅に合わせて伸縮。使える幅を超える長文/
  // 狭い画面では、テキストを横スクロール（往復）させて全文を読めるようにする。
  var RECOVERY_BADGE_INTERVAL = 2800; // 1メッセージの表示時間(ms)
  var RECOVERY_BADGE_SCROLL_SPEED = 45; // スクロール速度(px/秒)

  // バッジが使える最大幅（画像コンテナ幅 − 左右の余白）を求める
  function recoveryBadgeAvailWidth(badge) {
    var parent = badge.offsetParent || badge.parentElement;
    if (!parent) return Infinity;
    var left = parseFloat(window.getComputedStyle(badge).left) || 0;
    return parent.clientWidth - left * 2;
  }

  // 表示中スライドに合わせて背景幅を設定。収まらなければスクロールを付与
  function fitRecoveryBadge(badge, slide) {
    var cs = window.getComputedStyle(badge);
    var padX = parseFloat(cs.paddingLeft) + parseFloat(cs.paddingRight);
    var textW = slide.scrollWidth; // max-content の文字幅
    var availW = recoveryBadgeAvailWidth(badge);
    var contentW = textW + padX;

    // 直前のスクロール状態をリセット
    slide.classList.remove('is-scrolling');
    slide.style.removeProperty('--rb-scroll-dist');
    slide.style.removeProperty('--rb-scroll-dur');

    if (contentW <= availW) {
      // 収まる: 文字幅ぴったりに伸縮
      badge.style.width = Math.ceil(contentW + 1) + 'px';
    } else {
      // 収まらない: 最大幅にして中身をスクロール
      badge.style.width = Math.floor(availW) + 'px';
      var visibleW = availW - padX;
      var dist = Math.ceil(textW - visibleW);
      var dur = Math.max(3, dist / RECOVERY_BADGE_SCROLL_SPEED);
      slide.style.setProperty('--rb-scroll-dist', dist + 'px');
      slide.style.setProperty('--rb-scroll-dur', dur.toFixed(2) + 's');
      // reflow を挟んでからアニメーション開始（幅変更後に確実に効かせる）
      void slide.offsetWidth;
      slide.classList.add('is-scrolling');
    }
  }

  function initRecoveryBadgeRotation() {
    var badges = document.querySelectorAll('[data-badge-rotate]');
    badges.forEach(function (badge) {
      if (badge.dataset.badgeRotateInit) return;
      badge.dataset.badgeRotateInit = '1';
      var slides = badge.querySelectorAll('.product__badge__slide');
      if (slides.length < 2) return;
      var state = { i: 0 };
      badge._recoveryState = state;
      badge._recoverySlides = slides;
      fitRecoveryBadge(badge, slides[0]);
      setInterval(function () {
        slides[state.i].classList.remove('is-active');
        slides[state.i].classList.remove('is-scrolling');
        state.i = (state.i + 1) % slides.length;
        slides[state.i].classList.add('is-active');
        fitRecoveryBadge(badge, slides[state.i]);
      }, RECOVERY_BADGE_INTERVAL);
    });
  }

  // 画面幅が変わったら、表示中スライドを再計測して収まり/スクロールを更新
  var recoveryResizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(recoveryResizeTimer);
    recoveryResizeTimer = setTimeout(function () {
      document.querySelectorAll('[data-badge-rotate]').forEach(function (badge) {
        var state = badge._recoveryState;
        var slides = badge._recoverySlides;
        if (state && slides) fitRecoveryBadge(badge, slides[state.i]);
      });
    }, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecoveryBadgeRotation);
  } else {
    initRecoveryBadgeRotation();
  }
})();

(function() {

  // サブメニュー表示中はドロワー下部の画像をフェードで非表示にする
  function initDrawerImagesVisibility() {
    const drawerMenu = document.querySelector('[data-sliderule-pane]');
    if (!drawerMenu) return;

    const drawerInner = drawerMenu.closest('[data-drawer-scrolls]');
    if (!drawerInner) return;

    const imagesBottom = drawerInner.querySelector('.drawer__images-bottom');
    if (!imagesBottom) return;

    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.attributeName === 'data-sliderule-pane') {
          const pane = drawerMenu.getAttribute('data-sliderule-pane');
          if (pane === '0') {
            // ルートに戻る時：他のメニュー項目のアニメーション後に遅らせて表示
            imagesBottom.style.transitionDelay = '0.15s';
            imagesBottom.style.opacity = '';
            imagesBottom.style.pointerEvents = '';
          } else {
            // サブメニューに入る時：即座にフェードアウト
            imagesBottom.style.transitionDelay = '0s';
            imagesBottom.style.opacity = '0';
            imagesBottom.style.pointerEvents = 'none';
          }
        }
      });
    });

    observer.observe(drawerMenu, { attributes: true, attributeFilter: ['data-sliderule-pane'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawerImagesVisibility);
  } else {
    initDrawerImagesVisibility();
  }

})();
